<template>
  <div class="app-container">
    <component :is="currentList" :orders="orders"></component>
  </div>
</template>

<script>
import Available from './components/Available'
import Unavailable from './components/Unavailable'
import { selectCarAndUserRel, getStopCarInfo } from '@/api/park'
import { deepClone, getUrlParam, getTimeval, parseTime } from '@/utils'
import config from '@/config/index'
import { mapGetters } from 'vuex'
export default {
  name: 'My-Order',
  components: { Available, Unavailable },
  computed: {
    ...mapGetters(['wx_userInfo', 'zfb_userInfo', 'wx_token', 'token'])
  },
  created () {
    this.handleFilter()
  },
  data () {
    return {
      defultCarNumber: null, //默认车牌
      currentList: 'Unavailable',
      orders: [],
      config
    }
  },
  methods: {
    //查询绑定车牌
    handleFilter () {
      let _this = this
      let getInfo_Loading = _this.$toast.loading('加载中...')
      let params = {
        openid: _this.wx_userInfo ? _this.wx_userInfo.openid : _this.zfb_userInfo.userId
      }
      selectCarAndUserRel(params)
        .then(response => {
          let data = response.body
          getInfo_Loading.clear()
          _this.defultCarNumber = null
          for (let index = 0; index < data.length; index++) {
            const element = data[index]
            if (element.isDefaultCar) {
              _this.defultCarNumber = element.cardNumber
            }
          }
          if (!_this.defultCarNumber) {
            _this.$store.dispatch('app/setBackflow', _this.$options.name)
            _this.$router.push({ name: 'My-Car' })
          } else {
            _this.componentsValve()
          }
        })
        .catch(error => {
          getInfo_Loading.clear()
          _this.$notify({
            type: 'danger',
            message: error
          })
        })
    },
    componentsValve () {
      let _this = this
      let getInfo_Loading = _this.$toast.loading('加载中...')
      let cardNumberAsParams = _this.$route.query.cardNumber
      let type = _this.$route.query.type
      let params = {
        cardNumber: cardNumberAsParams || _this.defultCarNumber,
        parkId: getUrlParam("parkId") || _this.$route.query.parkId || -1,
        largeCar: getUrlParam("largeCar") || _this.$route.query.largeCar || false,
        code: Number(type) || _this.$enumObject.providerConfig[config.projectName].otherConfig.parkType,
        isMark: _this.$enumObject.providerConfig[config.projectName].otherConfig.parkType,
        sign: '',
        // nonceStr: "840BF8E41414D2C59612A06EE52AD390",
      }
      getStopCarInfo(params)
        .then(response => {
          getInfo_Loading.clear()
          let data = response.body
          if (data.entranceDate) {
            let exitDate = data.exitDate || parseTime(new Date())
            data.parkingTime = getTimeval(data.entranceDate, exitDate)
            if (data.parkingTime == '0天0时0分' && this.config.projectName == 'JNJT') {
              data.parkingTime = '不足1小时'
            }
          }
          if (Object.keys(data).length > 0) {
            _this.orders = deepClone(data)
            _this.currentList = 'Available'
          } else {
            _this.currentList = 'Unavailable'
            if (this.$enumObject.providerConfig[config.projectName].otherConfig.GoBill) {
              this.$router.replace({ name: 'Arrears-Bill-Temporary', query: { cardNumber: params.cardNumber, largeCar: params.largeCar, } })
            }
          }
        })
        .catch(error => {
          getInfo_Loading.clear()
          _this.$notify({
            type: 'danger',
            message: error
          })
        })
    }
  }
}
</script>